export const CaptchaYandex = {
	props: [
		'params',
	],
	data() {
		return {
			id: null,
			token: null,
			tokenPromise: null,
			isMounted: false,
		};
	},
	computed: {
		isInited() {
			return !(this.id === null || this.id === undefined);
		},
		isValid() {
			if (!this.isMounted) {
				return false;
			}
			return !!(this.params && this.params.publicKey && this.$refs.captcha);
		},
	},
	methods: {
		init() {
			if (!this.isValid) {
				return;
			}

			// ПРОВЕРКА: Если объект Яндекса еще не появился, ждем 100мс и пробуем снова
			if (typeof window.smartCaptcha === 'undefined') {
				setTimeout(() => {
					this.init();
				}, 100);
				return;
			}

			// Защита от двойного рендера (если капча уже создана)
			if (this.id !== null && this.id !== undefined) {
				return;
			}

			this.id = window.smartCaptcha.render(this.$refs.captcha, {
				sitekey: this.params.publicKey,
				invisible: true, // Чтобы сделать скрытой, поменяй на true
				// test: true,
				callback: this.onCaptchaCallback.bind(this),
			});
		},
		async getToken() {
			return new Promise((resolve) => {
				if (this.token) {
					resolve(this.token);
					return;
				}

				this.tokenPromise = {resolve};
				window.smartCaptcha.execute(this.id);
			});
		},
		reset() {
			this.token = null;
			// Добавляем проверку и try...catch, чтобы ошибка Яндекса не ломала наш скрипт
			if (window.smartCaptcha && this.id !== null && this.id !== undefined) {
				try {
					window.smartCaptcha.reset(this.id);
				} catch (e) {
					console.warn('SmartCaptcha reset warning:', e);
				}
			}
		},
		onCaptchaCallback(token) {
			this.token = token;
			if (this.tokenPromise && this.tokenPromise.resolve) {
				this.tokenPromise.resolve(token);
			}
		},
	},
	watch: {
		isValid(val) {
			if (val) {
				this.init();
			}
		},
	},
	mounted() {
		this.isMounted = true;
	},
	template: `<div ref="captcha" class="yandex-captcha-wrapper"></div>`,
};